
import numeral from 'numeral';
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
  name: 'AiDisclosureFinanceContent',
  components: { VueSlickCarousel },
  props: {
    disclosure: {
      type: Object,
      required: true,
    },
    aiFinanceData: {
      type: Array,
      required: true,
    },
    aiFinanceDataError: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      slickOptions: {
        dots: true,
        arrows: true,
        infinite: false,
        "fade": true,
        speed: 250,
        slidesToShow: 1,
        rows: 1,
        slidesToScroll: 1,
        autoplay: false,
        // "adaptiveHeight": true,
        cssEase: 'ease-in-out',
      },
    }
  },
  computed: {
    filteredAiFinanceData() {
      // Filter out items with null or undefined values
      if (this.aiFinanceDataError) {
        // console.log('Error fetching AI finance data');
        return [];
      }
      return this.aiFinanceData.filter(item => item?.data?.status && item?.data?.status === 'done');
    },
  },
  methods: {
    sortedFinancialMetrics(arr) {
      // Duplicate the array not to mutate
      const modifiedArr = [...arr];
      // Sort the financial metrics by key
      // Move the 3rd item (index 2) to the 4th position (index 3)
      const temp = modifiedArr.splice(2, 1)[0]; // remove the 3rd item
      modifiedArr.splice(3, 0, temp);
      // console.log('arr', modifiedArr);
      return modifiedArr;
    },
    checkPercentageTrend(val, key) {
      // Remove '%' and convert to float
      if (val == null) {
        return "neutral";
      }

      //else 
      const numericValue = parseFloat(val.replace('%', ''));
      // Check if it's greater than 0
      if (numericValue > 0 && key == 'Expenses') {
        return "up text-red-500";
      }

      else if (numericValue > 0) {
        return "up text-green-500";
      }
      else if (numericValue < 0 && key == 'Expenses') {
        return "down text-green-500 transform rotate-90";
      }
      else if (numericValue < 0) {
        return "down text-red-500 transform rotate-90";
      }
      else if (numericValue === 0 || numericValue == null) {
        return "neutral";
      } else {
        // Handle unexpected cases
        console.error('Unexpected value:', val);
        return "neutral";
      }
    }
  },
};
